import { render } from "./Assembly.vue?vue&type=template&id=64ed561c"
import script from "./Assembly.vue?vue&type=script&lang=js"
export * from "./Assembly.vue?vue&type=script&lang=js"

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__